import styled from 'styled-components';

export const LoginFormPageWrapper = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  -ms-flex-pack: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 70px 20px;

  .logo {
    margin-bottom: 20px;
  }
`;

export const LoginFormWrapper = styled.div`
  max-width: 325px;
  width: 100%;
  border-radius: 3px;
  background-color: #fff;
`;

export const LoginFormTitleWrapper = styled.div`
`;

export const LoginFormTitle = styled.h2`
  text-align: center;
  font-size: 25px;
  color: #3b3d3d;
`;

export const LoginFormInputWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-top: 1.1em;
  background-color: #fff;
  box-sizing: border-box;

  .input {
    margin-left: 11px;
    width: 302px;
    border-radius: 4px;
  }
`;

export const LoginFormButtonWrapper = styled.div`
  padding: 2em 1em;
  width: 100%;
  background-color: #fff;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: center;
  justify-content: center;
  box-sizing: border-box;
`;

export const LoginFormButton = styled.button`
  border: none;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.primary};
  padding: 15px 131px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  display: block;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
  font-size: 15px;
  font-weight: normal;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);

  &:hover {
    background-color: #fff;
    color: ${({ theme }) => theme.primary};
  }
`;

export const RegisterText = styled.div`
 display: flex;
 justify-content: center;
 margin-top: 20px;

  a {
    text-decoration: none;
    color: #7e8185;

    &:hover {
      color: ${({ theme }) => theme.primary};
    }
  }
`;
export const ReCaptchaWrapper = styled.div`
  margin-left: 11px;
  margin-top: 15px;
`;